import React from 'react'
import styled from 'styled-components'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Tabs,
    Tab,
    TextField,
    Typography,
    Snackbar,
    Alert,
    Box,
} from '@mui/material'

import useAddMediaDialog from 'logic/Dance/useAddMediaDialog.js'
import InputFileUpload from 'components/Control/InputFileUpload.js'
import InfoPopover from 'components/Control/Popover/InfoPopover.js'
import {Colors} from 'appearance/index.js'

const AddMediaDialog = ({open, handleClose}) => {
    const {
        isRtl,
        tab,
        acceptedMediaTypes,
        handleTabChange,
        setUploadedFile,
        setMediaUrl,
        handleSubmit,
        description,
        setDescription,
        isLoading,
        openSnackbar,
        setOpenSnackbar,
        mediaUrl,
        uploadedFile,
        isError,
        addMediaText,
        addText,
        cancelText,
        addFileMediaText,
        addLinkText,
        uploadMediaText,
        selectedMediaText,
        mediaUrlText,
        descriptionText,
        addMediaInfoText,
        supportedMediaTypesText,
        mediaAddedSuccessfullyText,
    } = useAddMediaDialog(handleClose)

    return (
        <>
            <StyledDialog
                open={open}
                onClose={handleClose}
                dir={isRtl ? 'rtl' : 'ltr'}>
                <StyledDialogTitle>
                    <InfoPopover body={addMediaInfoText} />
                    {addMediaText}
                </StyledDialogTitle>
                <StyledDialogContent>
                    <Tabs value={tab} onChange={handleTabChange}>
                        <Tab label={addFileMediaText} value="file" />
                        <Tab label={addLinkText} value="url" />
                    </Tabs>
                    <InputContainer>
                        {tab === 'file' ? (
                            <>
                                <Text>
                                    {supportedMediaTypesText} .mov .mkv .mp4 mp3
                                    .wav
                                </Text>
                                <Box display="flex" gap={2}>
                                    <InputFileUpload
                                        acceptedTypes={acceptedMediaTypes}
                                        text={uploadMediaText}
                                        setFile={setUploadedFile}
                                    />
                                    {uploadedFile.name && (
                                        <Typography noWrap variant="h5">
                                            {selectedMediaText}{' '}
                                            {uploadedFile.name}
                                        </Typography>
                                    )}
                                </Box>
                            </>
                        ) : (
                            <>
                                <StyledTextField
                                    label={mediaUrlText}
                                    type="url"
                                    value={mediaUrl}
                                    onChange={(e) =>
                                        setMediaUrl(e.target.value)
                                    }
                                />
                            </>
                        )}
                        <StyledTextField
                            autoFocus
                            type="text"
                            label={descriptionText}
                            value={description}
                            multiline
                            rows={4}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                    </InputContainer>
                    {isError && (
                        <Typography
                            variant="subtitle1"
                            color={Colors.ERROR_TEXT}>
                            Something went wrong
                        </Typography>
                    )}
                </StyledDialogContent>
                <DialogActions>
                    <DialogActions>
                        <Button variant="contained" onClick={handleClose}>
                            {cancelText}
                        </Button>
                        <Button
                            variant="contained"
                            onClick={handleSubmit}
                            disabled={isLoading}>
                            {addText}
                        </Button>
                    </DialogActions>
                </DialogActions>
            </StyledDialog>
            <Snackbar
                open={openSnackbar}
                autoHideDuration={4000}
                onClose={() => setOpenSnackbar(false)}
                anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}>
                <Alert
                    variant="filled"
                    onClose={() => setOpenSnackbar(false)}
                    severity="success">
                    {mediaAddedSuccessfullyText}
                </Alert>
            </Snackbar>
        </>
    )
}

export default AddMediaDialog

const StyledDialog = styled(Dialog)`
    & .MuiDialog-paper {
        width: 80%;
        max-width: 800px;
        min-height: 500px;
    }
`

const StyledDialogTitle = styled(DialogTitle)`
    background-color: ${Colors.APP_GRAY_LIGHT};
    display: flex;
    align-items: center;
`

const StyledDialogContent = styled(DialogContent)`
    padding: 20px;
    & .MuiTabs-root {
        margin-bottom: 20px;
    }
`

const StyledTextField = styled(TextField)`
    width: 60%;
`
const InputContainer = styled.div`
    flex-direction: column;
    display: flex;
    gap: 15px;
`
const Text = styled(Typography)``
